// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1cee00e6","455":"48d40a83","977":"ec86d1db"}[chunkId] + ".chunk.js";
};